import { Link } from "./Button/Link";

interface Props {
  to: string;
}

export function UserPageLoginPopover({ to }: Props) {
  return (
    <div className="fixed inset-0 z-10">
      <div className="w-full h-full backdrop-blur"></div>
      <div className="w-full h-full absolute top-0 flex items-center justify-center p-8">
        <div className="bg-black w-full max-w-sm flex flex-col rounded-2xl justify-center gap-3 p-6 border border-gray-800">
          <img
            src="/assets/poke-logo-short.svg"
            alt="poke logo"
            className="w-[120px]"
          />
          <span className="text-gray-200 text-3xl py-4">
            log in to find out if you’re a match
          </span>
          <Link variant="outline" to={to} className="w-full">
            log in
          </Link>
        </div>
      </div>
    </div>
  );
}
